import { LoadingOutlined, LockOutlined, MailOutlined } from "@ant-design/icons";
import { notification } from "antd";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { authSignIn } from "../../../apiservice/authService";
import { IAuthType } from "../../../apiservice/authService.type";
import useFormatApiRequest from "../../../hooks/formatApiRequest";
import {
  USER_TOKEN_KEY,
  USER_AUTH_DATA_KEY,
  USER_REFRESH_TOKEN_KEY,
} from "../../../hooks/useAuth";
import { useAppDispatch, useAppSelector } from "../../../Redux/reduxCustomHook";
import { storePlainString, storeJSON } from "../../../utils/localStorage";
import { NotificationType } from "../../../utils/mscType.type";
import "../userAuth.css";
import { RootState } from "../../../Redux/store";
import PasswordInput from "../../../components/sharedcomponents/PasswordBtn/Password-input";

const UserSignin = () => {
  const [formLoading, setFormLoading] = useState<boolean>(false);
  const [loadApi, setLoadApi] = useState(false);
  const [user, setUser] = useState<any>({});
  const [api, contextHolder] = notification.useNotification();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const authData: IAuthType = useAppSelector(
    (state: RootState) => state?.AuthData
  );

  useEffect(() => {
    if (authData?.data) {
      if (authData?.data?.credentials?.signupStatusId === 1) {
        navigate("/auth/verify-email");
      } else {
        navigate("/users/home");
      }
    }
  }, [authData, navigate]); // Added authData and navigate as dependencies

  const handleInputChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    setUser((values: any) => ({ ...values, [name]: value }));
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    setLoadApi(true);
    setFormLoading(true);
  };

  const result = useFormatApiRequest(
    () => authSignIn(user),
    loadApi,
    () => {
      setLoadApi(false);
    },
    () => {
      processApi();
    }
  );

  const processApi = async () => {
    if (result.httpState === "SUCCESS") {
      setFormLoading(false);
      const signinResult: IAuthType = result.data;
      storePlainString(USER_TOKEN_KEY, signinResult?.data?.accessToken || "");
      storePlainString(
        USER_REFRESH_TOKEN_KEY,
        signinResult?.data?.refreshToken || ""
      );
      storeJSON(USER_AUTH_DATA_KEY, signinResult);
      dispatch({ type: "AUTH_ADD_DATA", payload: signinResult });

      setTimeout(() => {
        navigate("/users/home");
      }, 1500);
      openNotificationWithIcon("info", "", "Login Success", "#D9FFB5");
    } else if (result.httpState === "ERROR") {
      setFormLoading(false);
      openNotificationWithIcon(
        "info",
        "",
        result.data?.response?.data?.errors?.[0].message ||
          result.data?.response?.data?.message ||
          result.errorMsg ||
          "Login Error",
        "#FFC2B7"
      );
    }
  };

  const openNotificationWithIcon = (
    type: NotificationType,
    message: string,
    description: string,
    background?: string
  ) => {
    api[type]({
      message,
      description,
      placement: "bottomRight",
      style: { background },
    });
  };

  return (
    <>
      {contextHolder}

      {/* Main Background */}
      <div className="flex flex-col min-h-screen bg-white dark:bg-stone-900">
        {/* Logo Section */}
        <div className="w-full  flex flex-col items-center">
          <div className="p-4 pt-12 pb-2">
            <img
              src={`${process.env.PUBLIC_URL + "/images/logobluebig.svg"}`}
              alt="Logo"
              className="w-32 h-auto"
            />
            <br />

            {/* <img
              src={`${process.env.PUBLIC_URL + "/images/logoblue.svg"}`}
              alt="Logo"
              className="w-32 h-auto"
            /> */}
          </div>

          <div className="p-4 w-full rounded-t-3xl">
            <p className="font-semibold fontKanitRegular text-xl text-center text-blue-800 dark:text-blue-400">
              Login into your account
            </p>
          </div>
        </div>

        {/* Form Area */}
        <div className="flex justify-center items-center p-4">
          <div className="w-full max-w-2xl p-4 rounded-xl bg-white dark:bg-stone-800 shadow-lg">
            <form onSubmit={handleSubmit}>
              {/* Email Address */}
              <div className="relative w-full mb-6">
                <label className="absolute -top-3 left-3 bg-white dark:bg-stone-800 px-1 text-blue-800 dark:text-blue-400 text-sm">
                  Email Address
                </label>
                <input
                  required
                  name="email"
                  value={user?.email}
                  onChange={handleInputChange}
                  type="email"
                  className="pl-10 pr-4 py-2 border dark:border-stone-600 rounded-lg w-full h-16 bg-transparent text-blue-800 dark:text-sky-300 placeholder-gray-500 dark:placeholder-stone-400"
                  placeholder="Enter your email"
                />
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <MailOutlined className="text-blue-800 dark:text-blue-400" />
                </div>
              </div>

              {/* Password */}
              <div className="relative w-full mb-2">
                {/* <label className="absolute -top-3 left-3 bg-white dark:bg-stone-800 px-1 text-blue-800 dark:text-blue-400 text-sm">
                  Password
                </label>
                <input
                  required
                  name="password"
                  value={user?.password}
                  onChange={handleInputChange}
                  type="password"
                  className="pl-10 pr-4 py-2 border dark:border-stone-600 rounded-lg w-full h-16 bg-transparent text-blue-800 dark:text-sky-300 placeholder-gray-500 dark:placeholder-stone-400"
                  placeholder="Enter your password"
                />
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <LockOutlined className="text-blue-800 dark:text-blue-400" />
                </div> */}
                <PasswordInput
                  required
                  name="password"
                  value={user?.password}
                  onChange={handleInputChange}
                  placeholder="Password"
                  icon={<LockOutlined className="text-blue-800 dark:text-blue-400" />}
                ></PasswordInput>
              </div>

              {/* Forget Password */}
              <div className="flex items-end justify-end mb-6">
                <Link to={"/auth/user-forget-password"}>
                  <span className="text-blue-800 dark:text-blue-400 fontAlbertSansRegular hover:underline">
                    Forget Password
                  </span>
                </Link>
              </div>

              {/* Login Button */}
              <div className="mb-4">
                <button className="w-full h-16 fontAlbertSansRegular text-white bg-blue-800 hover:bg-blue-700 dark:hover:bg-blue-600 rounded-xl text-lg">
                  {!formLoading ? (
                    "Sign In"
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )}
                </button>
              </div>

              <div className="mb-2">
                <Link to={"/users"}>
                  <button className="w-full h-16 fontAlbertSansRegular text-white bg-blue-800 hover:bg-blue-700 dark:hover:bg-blue-600 rounded-xl text-lg">
                    Continue Without Login
                  </button>
                </Link>
              </div>
            </form>

            {/* Don’t have an account yet? Sign up */}
            <div className="mt-4 text-center text-blue-800 dark:text-blue-400">
              <p>Don’t have an account yet?</p>
              <Link to={"/auth/signup"}>
                <span className="underline text-blue-800 dark:text-blue-400 hover:dark:text-blue-300">
                  Sign up
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserSignin;
